import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  height: 100%;
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Logo = styled(IconBox)`
  margin-bottom: 20px;
`;

export const Text = styled(Typography.Body)`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Link = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration-line: underline;
  text-underline-position: under;
`;
